import React, { useState, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './Multipleemployee.css';
import upload from '../../assets/upload.png';
import ProgressModal from './ProgressModal';

const Multipleemployee = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const fileInputRef = useRef();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleOpenProgressModal = () => {
    if (selectedFile) {
      setShowProgressModal(true);
    } else {
      console.log('No file selected.');
    }
  };

  const handleCloseProgressModal = () => {
    setShowProgressModal(false);
  };

  return (
    <div className="uploadContainer">
      <Modal show={true} centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Bulk upload employee detail</Modal.Title>
        </Modal.Header>
        <Modal.Body className="centered-modal-body">
          <div className="image-container">
            <label>
              <input
                type="file"
                onChange={handleFileChange}
                style={{ display: 'none' }}
                ref={fileInputRef}
              />
              <img src={upload} alt="Upload Image" className="centered-image" />
              <div className="dragText" onClick={handleUploadClick}>
                {selectedFile ? `Selected: ${selectedFile.name}` : 'Drag and drop your file(s) here or Click to upload'}
              </div>
              <div className="fileType">Files types: CSV.</div>
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="buttonContainer d-flex">
            <div className="downloadText">
              <p>Download sample file and ensure required fields are completed before upload</p>
            </div>
            <Button className="downloadUpload" variant="primary" onClick={handleOpenProgressModal}>
              Upload
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <ProgressModal show={showProgressModal} selectedFile={selectedFile} onClose={handleCloseProgressModal} />
    </div>
  );
};

export default Multipleemployee;
